import { Component } from "@angular/core";

@Component({
  selector: 'app-unauthorized',
  standalone: false,
  templateUrl: './app-unauthorized.component.html',
  styleUrl: './app-unauthorized.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class UnauthorizedComponent {
}